import React, { memo, useState } from 'react';
import { withStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import PF2MTooltip from '~/components/PF2MTooltip';
import PF2MDispatchIconMaker from '~/components/PF2MDispatchIconMaker';
import { useEquipmentStatusItem } from '../hooks/useEquipmentStatusItem';
import EquipmentStatusModal from '../EquipmentStatusModalV2';
import styles from './styles';

const EquipmentItem = memo(
  ({
    equip,
    isHighlighted,
    classes,
  }) => {
    const [openModal, setOpenModal] = useState(false);

    const { handleSelectItem } = useEquipmentStatusItem({
      ...equip,
    });

    const {
      height = '33.75px',
      width = '37.75px',
      iconName = 'excavator',
      warning = [],
      isBackground = false,
      typeMode,
    } = equip?.icon || {};

    const handleOpenModal = () => {
      handleSelectItem();
      setOpenModal(true);
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        handleOpenModal();
      }
    };

    return (
      <>
        <PF2MTooltip
          title={equip?.equip_name}
          PopperProps={{ disablePortal: true }}
        >
          <div
            key={equip?.id_equip}
            className={classNames(classes.wrapperEquipItem, isHighlighted ? classes.highlight : '')}
          >
            <div
              className={classes.equipIcon}
              onClick={handleOpenModal}
              role="button"
              tabIndex={0}
              onKeyDown={handleKeyDown}
            >
              <PF2MDispatchIconMaker
                height={height}
                width={width}
                iconName={iconName}
                settings={{
                  warnings: warning,
                  isBackground,
                  warningIconSize: '16px',
                }}
              />
            </div>
            <div className={classNames(classes.boxEquipLabel, classes[typeMode])}>
              <div className={classes.equipLabel}>{equip?.equip_name || ''}</div>
            </div>
          </div>
        </PF2MTooltip>
        {openModal && (
          <EquipmentStatusModal
            open={openModal}
            setOpen={setOpenModal}
            equip={equip}
          />
        )}
      </>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.equip.id_equip !== nextProps.equip.id_equip) {
      return false;
    }
    if (prevProps.isHighlighted !== nextProps.isHighlighted) {
      return false;
    }
    const statusChanged = prevProps.equip.code_type !== nextProps.equip.code_type
      || prevProps.equip.id_code_group !== nextProps.equip.id_code_group
      || prevProps.equip.equip_name !== nextProps.equip.equip_name
      || prevProps.equip.equip_group_name !== nextProps.equip.equip_group_name
      || prevProps.equip.code_type_name !== nextProps.equip.code_type_name
      || prevProps.equip.code_name !== nextProps.equip.code_name
      || prevProps.equip.equip_type_name !== nextProps.equip.equip_type_name
      || prevProps.equip.id_operator !== nextProps.equip.id_operator
      || prevProps.equip.point_id !== nextProps.equip.point_id
      || prevProps.equip.element_id !== nextProps.equip.element_id
      || prevProps.equip.comment !== nextProps.equip.comment
      || prevProps.equip.id_equip_group !== nextProps.equip.id_equip_group
      || prevProps.equip.start_timestamp !== nextProps.equip.start_timestamp
      || prevProps.equip.sent_from_tablet !== nextProps.equip.sent_from_tablet
      || prevProps.equip.duration !== nextProps.equip.duration;

    if (statusChanged) {
      return false;
    }

    if (prevProps.classes !== nextProps.classes) {
      return false;
    }
    return true;
  },
);

export default withStyles(styles)(EquipmentItem);

EquipmentItem.propTypes = {
  classes: PropTypes.object.isRequired,
  equip: PropTypes.shape({
    id_equip: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    code_type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id_code_group: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    equip_name: PropTypes.string,
    icon: PropTypes.shape({
      height: PropTypes.string,
      width: PropTypes.string,
      iconName: PropTypes.string,
      warning: PropTypes.array,
      isBackground: PropTypes.bool,
      typeMode: PropTypes.string,
    }),
  }).isRequired,
};
